import InquiryPage from "./InquiryPage";

export default InquiryPage;
